//Utils
import { saveSettingUrl } from "../urls/ShareSettingsURL";

//Constants
import { sendCreateOrUpdateRequest } from "../utils/api/apiUtils";

export async function saveSettingFn(ShareSettingsBean) {
  return sendCreateOrUpdateRequest(saveSettingUrl, ShareSettingsBean);
}
